<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form :model="table.where" label-width="77px" 
                   :inline="true"  @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
              <el-row :gutter="15">
                  <el-form-item label="订单状态:">
                    <el-select v-model="table.where.pay_status" placeholder="请选择订单状态">
                        <el-option
                          label="待发货"
                          value="3">
                        </el-option>
                        <el-option
                          label="待发货"
                          value="4">
                        </el-option>
                        <el-option
                          label="已完成"
                          value="5">
                        </el-option>
                        <el-option
                          label="退款中"
                          value="7">
                        </el-option>
                        <el-option
                          label="已关闭"
                          value="8">
                        </el-option>
                      </el-select>
                  </el-form-item>
                <el-form-item label="订单编号:">
                  <el-input placeholder="请输入订单编号" v-model="table.where.out_pay_num" clearable/>
                </el-form-item>
                <el-form-item label="商家编号:">
                     <el-select v-model="table.where.store_number" placeholder="请选择商家编号">
                         <el-option
                           v-for="item in store_info"
                           :key="item.value"
                           :label="item.store_name"
                           :value="item.number">
                         </el-option>
                       </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
                    </el-button>
                    <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                  </el-form-item>
              </el-row>
            </el-form>
            <!-- 操作按钮 -->
           <!-- <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodsorder:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:storegoodsorder:dall')">批量删除
                </el-button>
            </div> -->
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <!-- <el-table-column prop="user_id" label="用户id" sortable="custom" show-overflow-tooltip min-width="120"/> -->

                    <!-- <el-table-column prop="wx_pay_num" label="微信订单号" sortable="custom" show-overflow-tooltip min-width="120"/> -->

                    <el-table-column prop="out_pay_num" label="订单编号" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="store_number" label="商家编号" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    <el-table-column label="下单时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column prop="pay_status" label="订单状态" sortable="custom" show-overflow-tooltip
                        min-width="120">
                        <template slot-scope="{row}">
                            <div v-if="row.pay_status == 3">
                                待发货
                            </div>
                            <div v-else-if="row.pay_status == 4">
                                已发货
                            </div>
                            <div v-else-if="row.pay_status == 5">
                                已完成
                            </div>
                            <div v-else-if="row.pay_status == 6">
                                已完成
                            </div>
                            <div v-else-if="row.pay_status == 7">
                                退款中
                            </div>
                            <div v-else-if="row.pay_status == 8">
                                已关闭
                            </div>
                            <div v-else-if="row.pay_status == 9">
                                已完成
                            </div>
                        </template>
                    </el-table-column>
                    <!-- ,2表示未支付，3表示支付成功，4表示发货，5已收货待评价 6表示交易成功，7是退款中，8退款成功 ，9表示退款失败，10表示订单关闭，11表示用户删除订单状态显示已关闭 -->
                    <el-table-column prop="total" label="交易金额" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    <el-table-column prop="goods_integral" label="对应积分" sortable="custom" show-overflow-tooltip
                        min-width="120" />
                    <el-table-column label="订单跟踪" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="trackInfo(row)"  type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsorder:trackInfo')">查看详情</el-link>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="商品信息" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="goodsInfo(row)"  type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsorder:goodsInfo')">查看详情</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="下单信息" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="orderInfo(row)"  type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsorder:orderInfo')">查看详情</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="客服对话记录" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="translateInfo(row)"  type="primary" :underline="false"
                                v-if="permission.includes('sys:storegoodsorder:translateInfo')">查看详情</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            
                            <el-popconfirm title="确定要取消订单此订单吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" type="danger" :underline="false"
                                    v-if="permission.includes('sys:storegoodsorder:delete')">取消订单</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog title="商品信息" :visible.sync="goodsShow" width="800px" @closed="editForm={}"
            :destroy-on-close="true" :lock-scroll="false">
            <div class="ikz-goods" v-if="goodsShowForm">
                <div class="ikz-goods-left">
                    <img class="ikz-goods-img" v-if="goodsShowForm.goods_img" :src="goodsShowForm.goods_img[0]" />
                </div>
                <div class="ikz-goods-right">
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">商品名称：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.goods_name}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">所属类别：</div>
                        <div class="ikz-goods-desc" v-for="(item,index) in goodsShowForm.goods_category" :key="index"><el-tag size="small">{{item.title}}</el-tag></div>
                    </div>
                    
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">商品编号：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.goods_code}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">商家编号：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.store_number}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">规格属性：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.sku_info||'默认规格'}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">价格：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.total}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">对应积分：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.goods_integral}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">购买数量：</div>
                        <div class="ikz-goods-desc">{{goodsShowForm.goods_num}}</div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="goodsShow=false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 下单信息 -->
        <el-dialog title="下单信息" :visible.sync="orderShow" width="800px" @closed="editForm={}"
            :destroy-on-close="true" :lock-scroll="false">
            <div class="ikz-goods" v-if="orderShowForm">
                <div class="ikz-goods-right" v-if="orderShowForm.user_info">
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">会员号：</div>
                        <div class="ikz-goods-desc">{{orderShowForm.user_info.user_code}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">会员等级：</div>
                        <div class="ikz-goods-desc" >
                            <el-tag size="small" v-if="orderShowForm.user_info.grade == 0">普通会员</el-tag>
                            <el-tag size="small" v-if="orderShowForm.user_info.grade == 1">{{orderShowForm.user_grade.one_title}}</el-tag>
                            <el-tag size="small" v-if="orderShowForm.user_info.grade == 2">{{orderShowForm.user_grade.two_title}}</el-tag>
                            <el-tag size="small" v-if="orderShowForm.user_info.grade == 3">{{orderShowForm.user_grade.three_title}}</el-tag>
                        </div>
                    </div>
                    
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">姓名：</div>
                        <div class="ikz-goods-desc">{{orderShowForm.user_name}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">联系方式：</div>
                        <div class="ikz-goods-desc">{{orderShowForm.user_mobile}}</div>
                    </div>
                    <div class="ikz-goods-item">
                        <div class="ikz-goods-title">地址：</div>
                        <div class="ikz-goods-desc">{{orderShowForm.region}}{{orderShowForm.address}}</div>
                    </div>
                    
                </div>
            </div>
            <div slot="footer">
                <el-button @click="orderShow=false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "SysStoreGoodsOrder",
        data() {
            return {
                table: {
                    url: '/storegoodsorder/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                goodsShow:false,
                editForm: {}, // 表单数据
                goodsShowForm:{},
                orderShow:false,//下单弹窗
                orderShowForm:{},//下单数据信息
                store_info:[]
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
            this.shopInfo();
        },
        methods: {
            shopInfo(){
                this.$http.get('/store/listInfo').then(res => {
                  if (res.data.code === 0) {
                    this.store_info = res.data.data;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                }).catch(e => {
                  this.$message.error(e.message);
                });
            },
            /**
             * 显示编辑
             */
            goodsInfo(row) {
                this.$http.get('/storegoodsorder/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.goodsShowForm = res.data.data;
                        
                        this.goodsShow = true;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            orderInfo(row){
                this.$http.get('/storegoodsorder/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.orderShowForm = res.data.data;
                        
                        this.orderShow = true;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/storegoodsorder/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的订单吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/storegoodsorder/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/storegoodsorder/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
    .ikz-goods{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .ikz-goods-img{
        width: 200px;
        height: 200px;
    }
    .ikz-goods-item{
        display: flex;
        align-items: center;
    }
    .ikz-goods-title{
        line-height: 30px;
        width: 80px;
    }
</style>
